/* Malichus encyclopedia - corrections to things a reader can see.
   Five problems, each one visible on the page:
   1. the numbered dots on the anatomy drawing sat on top of each other in the
      middle of the dial, so several numbers could not be read or tapped;
   2. the balance-wheel caption said four swings a second for 28,800 an hour,
      which is arithmetically wrong: 28,800 an hour is eight a second;
   3. the rate slider ran right-to-left while the scale above it ran
      left-to-right, so dragging the slider right moved the marker left;
   4. the back-to-top button was a wide pill in the bottom-left corner, which
      on a right-to-left page is where the standards table starts its names;
   5. a picture frame holding a single photo still used the coverflow's fixed
      height and 62% width cap, so the photo sat small inside a black box.
   These files build their markup themselves, so the fixes are applied to the
   rendered page rather than to those files. */
(function(){
if(window.__mzlfix)return;window.__mzlfix=1;

/* ---------------------------------------------------------------- 1 + 3 */
var CSS=[
/* the lug-width dimension line is not a selectable part in the anatomy view,
   and its caption landed under the strap dot */
'#mz .la .lw-svg g[data-part="lugwidth"]{display:none!important}',
/* the rate slider must run the same way as the scale drawn above it */
'#mz .mz-prec input[type=range]{direction:ltr!important}',
/* The back-to-top button is fixed in the bottom-left corner. On a right-to-left
   page that corner is where the standards table starts its names, and the wide
   pill was long enough to hide the first one. A round button covers a third of
   the width; the wording comes back on hover and on keyboard focus, and the
   button keeps its own label for screen readers either way. Its height above
   the bottom edge is left alone, since that clearance was chosen for the
   phone browser bars. */
'.mz-up{left:8px!important;width:44px!important;height:44px!important;padding:0!important;gap:0!important;'+
 'justify-content:center!important;overflow:hidden!important;white-space:nowrap!important;'+
 'transition:width .16s ease,padding .16s ease!important}',
'.mz-up>span{display:none!important}',
'.mz-up:hover,.mz-up:focus-visible{width:auto!important;padding:10px 16px!important;gap:6px!important}',
'.mz-up:hover>span,.mz-up:focus-visible>span{display:inline!important}',
/* The picture frame was built as a coverflow: a fixed-height stage with each
   image capped at 62% of its width so the neighbouring pictures peek in at the
   sides. With a single picture there are no neighbours, so all that cap did was
   shrink the photo and surround it with black. A frame holding one picture now
   sizes itself to that picture, and a frame holding several gives the one in
   front more room. */
'#mz .mzx-cf.mzx-one{height:auto!important;min-height:0!important;overflow:visible!important;padding:8px 0!important}',
'#mz .mzx-cf.mzx-one img{position:static!important;transform:none!important;opacity:1!important;'+
 'display:block!important;margin:0 auto!important;width:auto!important;height:auto!important;'+
 'max-width:min(96%,900px)!important;max-height:min(74vh,620px)!important}',
'#mz .mzx-cf:not(.mzx-one) img{max-width:74%!important;height:88%!important}',
/* The founder portrait beside the brand facts was cropped to fill its box, so
   a picture that is not portrait-shaped lost its edges. It is shown whole
   instead, on the panel colour. The small arched portrait in the fact strip
   keeps its crop: it is a medallion 84px across, framed just above centre to
   hold the face, and fitting a whole picture inside that arch would leave it
   floating in a gap. */
'#mz .mz-bfd img{object-fit:contain!important;max-height:260px!important;background:#f4ebda!important}'
].join('\n');
try{
 var s=document.createElement('style');s.setAttribute('data-mz','lfix');
 s.textContent=CSS;document.head.appendChild(s);
}catch(e){}

/* ------------------------------------------------------------------- 2 */
var TEXT=[
 ['٤ اهتزازات في الثانية = 28,800 في الساعة',
  '8 اهتزازات في الثانية = 28,800 في الساعة'],
 ['4 SWINGS A SECOND = 28,800 AN HOUR','8 BEATS A SECOND = 28,800 AN HOUR']
];

/* ------------------------------------------------------------------- 1 */
/* front view, viewBox 30 60 240 280. The dial sits at (150,200): sub-dials at
   (118,200), (182,200), (150,238), the tick ring at radius 50-72. Each dot is
   28px across, so anchors are kept at least 34px apart and on the part they
   name. */
var FRONT={
 strap:[150,80], lugs:[100,112], bezel:[150,122], chrono:[186,160],
 pushers:[229,158], hands:[150,170], subdials:[118,200], crown:[235,200],
 markers:[196,236], dial:[108,246], 'case':[150,290]
};
var VBF=[30,60,240,280];

function fixAnatomy(root){
 var dots=root.querySelectorAll('.la-dot[data-part]');
 if(!dots.length)return;
 /* the section holds more than one drawing, so take the view from the dots
    themselves rather than from the first drawing on the page */
 var svg=dots[0].ownerSVGElement;if(!svg)return;
 var vb=(svg.getAttribute('viewBox')||'').split(/\s+/).map(Number);
 /* only the front view is re-anchored; side and back are already clear */
 if(vb.length!==4||vb[0]!==VBF[0]||vb[1]!==VBF[1]||vb[2]!==VBF[2]||vb[3]!==VBF[3])return;
 var selXY=null;
 for(var i=0;i<dots.length;i++){
  var k=dots[i].getAttribute('data-part'),p=FRONT[k];
  if(!p)return;                      /* an unexpected part: leave the view alone */
  dots[i].setAttribute('transform','translate('+p[0]+' '+p[1]+')');
  if(dots[i].classList.contains('on'))selXY=p;
 }
 /* the leader line and arrow run from the selected dot down to the card */
 var lead=svg.querySelector('.la-lead');
 if(lead&&selXY){
  var bottom=VBF[1]+VBF[3];
  var ln=lead.querySelector('line'),ar=lead.querySelector('path');
  if(ln){ln.setAttribute('x1',selXY[0]);ln.setAttribute('x2',selXY[0]);
         ln.setAttribute('y1',selXY[1]+11);ln.setAttribute('y2',bottom-14)}
  if(ar)ar.setAttribute('d','M'+(selXY[0]-9)+' '+(bottom-20)+'L'+selXY[0]+' '+(bottom-5)+'L'+(selXY[0]+9)+' '+(bottom-20)+'Z');
 }
 /* the little notch under the card points at the dot it came from */
 var notch=root.querySelector('.la-card .la-notch');
 if(notch&&selXY)notch.style.left=((selXY[0]-VBF[0])/VBF[2]*100).toFixed(1)+'%';
}

function fixText(root){
 /* the caption is an SVG label, so only those are walked */
 var t=root.querySelectorAll('svg text');
 for(var i=0;i<t.length;i++){
  var el=t[i];
  if(el.children.length)continue;
  var v=el.textContent;if(!v)continue;
  for(var j=0;j<TEXT.length;j++){
   if(v.indexOf(TEXT[j][0])>=0){el.textContent=v.split(TEXT[j][0]).join(TEXT[j][1]);break}
  }
 }
}

/* A frame holding one picture is marked so the stylesheet above can let it
   size itself to that picture instead of to the coverflow's fixed height. */
function fixFrames(root){
 var f=root.querySelectorAll('.mzx-cf'),i,n;
 for(i=0;i<f.length;i++){
  n=f[i].querySelectorAll('img').length;
  if(n===1)f[i].classList.add('mzx-one');
  else f[i].classList.remove('mzx-one');
 }
}

var pending=0;
function pass(){
 pending=0;
 try{
  var root=document.getElementById('mz');if(!root)return;
  fixAnatomy(root);fixText(root);fixFrames(root);
 }catch(e){}
}
function schedule(){ if(pending)return;pending=1;setTimeout(pass,40) }

pass();
setTimeout(pass,400);setTimeout(pass,1500);
try{
 var root=document.getElementById('mz');
 if(root&&window.MutationObserver){
  new MutationObserver(schedule).observe(root,{childList:true,subtree:true});
 }
}catch(e){}

})();